import { openMeldProfileIdSchema } from "../daemon/profile-identity.js";
import { START_BOUNDED_ID_SCHEMA, START_TRIMMED_NON_EMPTY_STRING_SCHEMA } from "./shared.js";
import * as z$1 from "zod/v4";
//#region src/schemas/start/onboarding-plan.ts
const onboardingActionIdSchema = z$1.enum([
	"sign_in",
	"set_display_name",
	"enter_space",
	"bring_agents",
	"connect_this_computer"
]);
const onboardingDecisionStatusSchema = z$1.enum([
	"done",
	"available",
	"blocked"
]);
const onboardingReasonCodeSchema = z$1.enum([
	"auth.signed_out",
	"auth.signed_in",
	"identity.name_missing",
	"identity.name_present",
	"space.none_in_context",
	"space.not_joined",
	"space.joined",
	"agents.none_yet",
	"agents.addable_present",
	"agents.member_present",
	"computer.connected",
	"computer.connecting",
	"computer.not_connected",
	"computer.evidence_unavailable"
]);
const onboardingPlanDecisionSchema = z$1.strictObject({
	id: onboardingActionIdSchema,
	status: onboardingDecisionStatusSchema,
	blocking: z$1.boolean(),
	reason: onboardingReasonCodeSchema,
	run: z$1.union([START_TRIMMED_NON_EMPTY_STRING_SCHEMA, z$1.null()]),
	afterRun: z$1.union([START_TRIMMED_NON_EMPTY_STRING_SCHEMA, z$1.null()])
});
const onboardingPlanSummarySchema = z$1.enum(["nothing_to_do", "actions_pending"]);
const onboardingPlanSchema = z$1.strictObject({
	decisions: z$1.array(onboardingPlanDecisionSchema).readonly(),
	summary: onboardingPlanSummarySchema
});
const onboardingProfileKindSchema = z$1.enum(["human", "agent"]);
const onboardingAccountProfileSchema = z$1.strictObject({
	profileId: openMeldProfileIdSchema,
	kind: onboardingProfileKindSchema,
	name: START_TRIMMED_NON_EMPTY_STRING_SCHEMA,
	active: z$1.boolean()
});
const onboardingAuthFactSchema = z$1.discriminatedUnion("signedIn", [z$1.strictObject({
	signedIn: z$1.literal(true),
	userId: START_BOUNDED_ID_SCHEMA,
	actingProfileId: openMeldProfileIdSchema,
	actingDisplayName: z$1.union([START_TRIMMED_NON_EMPTY_STRING_SCHEMA, z$1.null()])
}), z$1.strictObject({ signedIn: z$1.literal(false) })]);
const onboardingSpaceContextSchema = z$1.union([z$1.strictObject({
	spaceId: START_BOUNDED_ID_SCHEMA,
	actingProfileIsMember: z$1.boolean(),
	memberAgentProfileIds: z$1.array(openMeldProfileIdSchema).readonly()
}), z$1.null()]);
const onboardingDeviceStatusSchema = z$1.enum([
	"connected",
	"connecting",
	"not_connected",
	"unknown"
]);
const onboardingDeviceFactSchema = z$1.strictObject({ status: onboardingDeviceStatusSchema });
const onboardingContextSlotSchema = z$1.discriminatedUnion("kind", [z$1.strictObject({ kind: z$1.literal("none") }), z$1.strictObject({
	kind: z$1.literal("web_setup_handoff"),
	startSessionToken: START_BOUNDED_ID_SCHEMA
})]);
const onboardingFactsSchema = z$1.strictObject({
	auth: onboardingAuthFactSchema,
	accountProfiles: z$1.array(onboardingAccountProfileSchema).readonly(),
	space: onboardingSpaceContextSchema,
	device: onboardingDeviceFactSchema,
	context: onboardingContextSlotSchema
}).superRefine((value, ctx) => {
	const seenProfileIds = /* @__PURE__ */ new Set();
	for (const [index, profile] of value.accountProfiles.entries()) {
		if (seenProfileIds.has(profile.profileId)) {
			ctx.addIssue({
				code: "custom",
				message: "accountProfiles must not contain duplicate profileId values",
				path: [
					"accountProfiles",
					index,
					"profileId"
				]
			});
			continue;
		}
		seenProfileIds.add(profile.profileId);
	}
});
//#endregion
export { onboardingAccountProfileSchema, onboardingActionIdSchema, onboardingAuthFactSchema, onboardingContextSlotSchema, onboardingDecisionStatusSchema, onboardingDeviceFactSchema, onboardingDeviceStatusSchema, onboardingFactsSchema, onboardingPlanDecisionSchema, onboardingPlanSchema, onboardingPlanSummarySchema, onboardingProfileKindSchema, onboardingReasonCodeSchema, onboardingSpaceContextSchema };

//# sourceMappingURL=onboarding-plan.js.map